import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { initAntiDevTools } from "./utils/antiDevTools.js";

// Guard: production only — no effect in dev
initAntiDevTools();

// Global fetch interceptor to catch BUSINESS_EXPIRED and BUSINESS_LOCKED errors
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  
  if (response.status === 403) {
    const clone = response.clone();
    try {
      const data = await clone.json();
      if (data.errorType === 'BUSINESS_EXPIRED' || data.errorType === 'BUSINESS_LOCKED') {
        // Debounce alert to prevent multiple popups
        if (!window.__blockAlertShown) {
          window.__blockAlertShown = true;
          alert(data.message || 'Error: Service is locked or expired.');
          setTimeout(() => { window.__blockAlertShown = false; }, 3000);
        }
      }
    } catch (e) {
      // ignore JSON parse errors
    }
  }
  
  return response;
};

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
